export default function Unauthorized() {
  return <h2>Not Authorized</h2>;
}
